









































































































































































































































































































































































/* eslint-disable */
import Vue from 'vue';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import textfit from 'textfit';
import ShareBar from '@/components/Share/ShareBar.vue';

const onResize = function() {
  textfit(document.querySelectorAll('.detail-firma h1'), { multiLine: true, widthOnly: true, maxFontSize: 40 });
};

export default Vue.extend({
  name: 'Detail',
  components: {
    Header,
    Footer,
    ShareBar,
  },
  data() {
    return {
      lehrstelle: {
        description: '',
        location: '',
        bezirk: '',
        job_url: '',
      },
    };
  },

  mounted() {
    this.$store.dispatch('loadLehrstelleById', this.$route.params.id).then((result: object) => {
      // @ts-ignore
      this.lehrstelle = result;

      const ogurl = document.createElement('meta');
      ogurl.setAttribute('property', 'og:url');
      ogurl.setAttribute('content', document.location.toString());
      document.head.appendChild(ogurl);

      const title = document.createElement('meta');
      title.setAttribute('property', 'og:title');
      title.setAttribute('content', this.lehrstelle.title);
      document.head.appendChild(title);

      const description = document.createElement('meta');
      description.setAttribute('property', 'og:description');
      description.setAttribute('content', this.description);
      document.head.appendChild(description);

      if (this.lehrstelle.organisationIMG) {
        const organizationIMG = document.createElement('meta');
        organizationIMG.setAttribute('property', 'og:image');
        organizationIMG.setAttribute('content', this.lehrstelle.organisationIMG);
        document.head.appendChild(organizationIMG);
      }
    });

    window.addEventListener('resize', onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', onResize);
  },
  updated() {
    onResize();
  },

  methods: {
    imagepath: function(image: string) {
      return `${this.$store.state.imagedir}${image}`;
    },
    parseUrl: function(url: string) {
      // eslint-disable-next-line
      let urls: any = url;
      if (url.includes(';')) {
        urls = url.split(';');
      }

      if (url.includes(',')) {
        urls = url.split(',');
      }
      if (Array.isArray(urls)) {
        return urls.map((item) => {
          if (!item.trim().startsWith('https://') && !item.trim().startsWith('http://')) {
            return `http://${item.trim()}`;
          } else {
            return item.trim();
          }
        });
      } else {
        if (!urls.trim().startsWith('https://') && !urls.trim().startsWith('http://')) {
          urls = `http://${urls}`;
        }

        return [].concat(urls);
      }
    },
  },
  computed: {
    jobUrl: function() {
      // @ts-ignore
      if (this.lehrstelle.job_url != '') {
        // @ts-ignore
        return this.lehrstelle.job_url;
      }
      const re = /(https?:\/\/[a-zA-Z0-9_/:#?.-]*)/gm;
      // @ts-ignore
      const url = this.lehrstelle.description.match(re);
      if (url?.length > 0) {
        return url;
      }

      return false;
    },
    description: function() {
      if (this.jobUrl) {
        // @ts-ignore
        return this.lehrstelle.description.replace(this.jobUrl, '');
      }
      // @ts-ignore
      return this.lehrstelle.description;
    },
    ort: function() {
      // @ts-ignore
      if (this.lehrstelle.location != this.lehrstelle.bezirk) {
        // @ts-ignore
        return `${this.lehrstelle.location}, ${this.lehrstelle.bezirk}`;
      }
      // @ts-ignore
      return this.lehrstelle.location || '';
    },
  },
});
